module.exports = __webpack_public_path__ + "static/img/tc2.a1870eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/tc2.png
// module id = PpIG
// module chunks = 1